/* Iron Gate Knives — Built-to-Order landing page behaviours */
(function () {
  'use strict';

  // 1. Smooth-scroll for in-page anchors (data-scroll="#id")
  document.querySelectorAll('[data-scroll]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      var sel = el.getAttribute('data-scroll');
      var target = document.querySelector(sel);
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth', block: 'start' }); }
    });
  });

  // 2. Countdown to the drop (reads data-deadline ISO string)
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var deadline = new Date(cd.getAttribute('data-deadline')).getTime();
    var slots = {
      d: cd.querySelector('[data-d]'), h: cd.querySelector('[data-h]'),
      m: cd.querySelector('[data-m]'), s: cd.querySelector('[data-s]')
    };
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = deadline - Date.now();
      if (diff <= 0) {
        cd.classList.add('is-live');
        if (slots.d) slots.d.textContent = '00';
        if (slots.h) slots.h.textContent = '00';
        if (slots.m) slots.m.textContent = '00';
        if (slots.s) slots.s.textContent = '00';
        return;
      }
      var sec = Math.floor(diff / 1000);
      if (slots.d) slots.d.textContent = pad(Math.floor(sec / 86400));
      if (slots.h) slots.h.textContent = pad(Math.floor((sec % 86400) / 3600));
      if (slots.m) slots.m.textContent = pad(Math.floor((sec % 3600) / 60));
      if (slots.s) slots.s.textContent = pad(sec % 60);
    };
    tick(); setInterval(tick, 1000);
  }

  // 3. FAQ accordion
  document.querySelectorAll('.iglp-faq__q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!open));
      var panel = btn.parentElement.querySelector('.iglp-faq__a');
      if (panel) panel.style.maxHeight = open ? '0' : panel.scrollHeight + 'px';
    });
  });

  // 4. Sticky CTA bar — show after hero scrolled past
  var sticky = document.querySelector('.iglp-sticky');
  var hero = document.querySelector('.iglp-hero');
  if (sticky && hero) {
    var io = new IntersectionObserver(function (entries) {
      sticky.classList.toggle('show', !entries[0].isIntersecting);
    }, { threshold: 0 });
    io.observe(hero);
  }

  // 6. Nav drawer (hidden hamburger menu)
  var burger = document.querySelector('.iglp-burger');
  var nav = document.getElementById('iglp-nav');
  if (burger && nav) {
    var openNav = function () {
      nav.classList.add('is-open'); nav.setAttribute('aria-hidden', 'false');
      burger.setAttribute('aria-expanded', 'true'); document.body.classList.add('iglp-nav-open');
    };
    var closeNav = function () {
      nav.classList.remove('is-open'); nav.setAttribute('aria-hidden', 'true');
      burger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('iglp-nav-open');
    };
    burger.addEventListener('click', openNav);
    nav.querySelectorAll('.iglp-nav__close, .iglp-nav__backdrop').forEach(function (el) {
      el.addEventListener('click', closeNav);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeNav(); });
  }

  // 5. Klaviyo capture — email always, SMS if phone provided
  var form = document.querySelector('[data-klaviyo-form]');
  if (form) {
    var company = form.getAttribute('data-company');       // Sb9mTS
    var emailListId = form.getAttribute('data-email-list'); // SY2bfD
    var smsListId = form.getAttribute('data-sms-list');     // TB3dSg
    var msg = form.querySelector('.msg');

    var subscribe = function (listId, attrs) {
      return fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + company, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify({
          data: {
            type: 'subscription',
            attributes: {
              custom_source: 'Built-to-Order Ad Landing',
              profile: { data: { type: 'profile', attributes: attrs } }
            },
            relationships: { list: { data: { type: 'list', id: listId } } }
          }
        })
      });
    };

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var email = (form.querySelector('[name="email"]') || {}).value || '';
      var phone = (form.querySelector('[name="phone"]') || {}).value || '';
      if (!email) { msg.textContent = 'Pop your email in first.'; msg.className = 'msg err'; return; }
      msg.textContent = 'Locking you in…'; msg.className = 'msg';

      var props = { drop_interest_2026_06_11: true, source: 'ad-landing' };
      var calls = [ subscribe(emailListId, { email: email, properties: props }) ];
      if (phone) {
        calls.push(subscribe(smsListId, { email: email, phone_number: phone, properties: props }));
      }
      Promise.all(calls).then(function () {
        msg.textContent = "You're on the list. We'll text + email you the second it drops.";
        msg.className = 'msg ok';
        form.reset();
        if (window.gtag) window.gtag('event', 'generate_lead', { method: 'lp_drop_capture' });
        if (window.fbq) window.fbq('track', 'Lead');
      }).catch(function () {
        msg.textContent = 'Something went wrong. Try again in a sec.';
        msg.className = 'msg err';
      });
    });
  }
})();
